import React from "react";
import { Box, Stack, Typography, Button, Divider, Chip } from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { NavLink, useNavigate } from "react-router-dom";

// (Opcional) Se quiser realmente deslogar do Firebase, descomenta essas 2 linhas:
// import { auth } from "../../services/firebase/auth";
// import { signOut } from "firebase/auth";

const Item = ({ to, icon, label, onNavigate, end }) => (
  <Button
    component={NavLink}
    to={to}
    end={end} // 👈 AQUI (só funciona no NavLink)
    onClick={onNavigate}
    fullWidth
    sx={{
      justifyContent: "flex-start",
      gap: 1.2,
      px: 1.6,
      py: 1.2,
      borderRadius: 1,
      color: "text.primary",
      border: "1px solid rgba(11,18,32,0.06)",
      bgcolor: "rgba(255,255,255,0.70)",
      "&:hover": {
        bgcolor: "rgba(37,99,235,0.06)",
        borderColor: "rgba(37,99,235,0.16)",
      },
      "&.active": {
        bgcolor: "rgba(37,99,235,0.10)",
        borderColor: "rgba(37,99,235,0.22)",
        color: "primary.main",
      },
    }}
  >
    {icon}
    <Typography fontWeight={850} sx={{ textAlign: "left" }}>
      {label}
    </Typography>
  </Button>
);

export default function AdminSidebar({ onNavigate }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Se quiser logout real:
    // await signOut(auth);

    // Por enquanto: só volta pro login (ou home, se preferir)
    onNavigate?.();
    navigate("/login");
  };

  return (
    <Box
      sx={{
        p: 2.3,
        borderRadius: 1,
        height: { xs: "auto", lg: "88vh" },
        bgcolor: "background.paper",
        border: "1px solid rgba(11,18,32,0.08)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* CONTEÚDO */}
      <Stack spacing={2} sx={{ flex: 1 }}>
        {/* Brand */}
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 1,
              bgcolor: "rgba(37,99,235,0.12)",
              border: "1px solid rgba(37,99,235,0.20)",
              display: "grid",
              placeItems: "center",
              fontWeight: 1000,
              color: "primary.main",
            }}
          >
            O
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontWeight={1000} fontSize={15}>
                ONURB Admin
              </Typography>
              <Chip
                label="Internal"
                size="small"
                sx={{
                  borderRadius: 1,
                  bgcolor: "rgba(11,18,32,0.06)",
                  fontWeight: 900,
                }}
              />
            </Stack>
            <Typography fontSize={12} color="text.secondary">
              Painel interno do sistema
            </Typography>
          </Box>
        </Stack>

        <Divider />

        {/* Seção principal */}
        <Stack spacing={0.8}>
          <Typography
            fontSize={11}
            sx={{
              color: "text.secondary",
              fontWeight: 900,
              letterSpacing: 0.6,
            }}
          >
            VISÃO
          </Typography>

          <Item
            to="/admin"
            end
            icon={<DashboardRoundedIcon fontSize="small" />}
            label="Dashboard"
            onNavigate={onNavigate}
          />
          <Item
            to="/admin/organizers/requests"
            icon={<HowToRegRoundedIcon fontSize="small" />}
            label="Solicitações"
            onNavigate={onNavigate}
          />
        </Stack>

        {/* Seção pronta pra crescer */}
        <Stack spacing={0.8}>
          <Typography
            fontSize={11}
            sx={{
              color: "text.secondary",
              fontWeight: 900,
              letterSpacing: 0.6,
            }}
          >
            OPERAÇÕES
          </Typography>

          <Item
            to="/admin/relatorios"
            icon={<AnalyticsRoundedIcon fontSize="small" />}
            label="Relatórios"
            onNavigate={onNavigate}
          />
          <Item
            to="/admin/suporte"
            icon={<SupportAgentRoundedIcon fontSize="small" />}
            label="Suporte"
            onNavigate={onNavigate}
          />
        </Stack>
      </Stack>

      {/* RODAPÉ FIXO */}
      <Box sx={{ pt: 2 }}>
        <Divider sx={{ mb: 1.6 }} />

        <Button
          onClick={handleLogout}
          fullWidth
          startIcon={<LogoutRoundedIcon fontSize="small" />}
          sx={{
            justifyContent: "flex-start",
            px: 1.6,
            py: 1.2,
            borderRadius: 1,
            border: "1px solid rgba(220,38,38,0.18)",
            bgcolor: "rgba(220,38,38,0.06)",
            color: "error.main",
            "&:hover": {
              bgcolor: "rgba(220,38,38,0.10)",
              borderColor: "rgba(220,38,38,0.28)",
            },
          }}
        >
          <Typography fontWeight={900}>Sair</Typography>
        </Button>

        <Typography
          fontSize={11}
          color="text.secondary"
          sx={{ mt: 1.2, textAlign: "left" }}
        >
          v0.1 • ONURB Internal
        </Typography>
      </Box>
    </Box>
  );
}
